import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  background-color: #f3f3f3;
  flex-grow: 1;
`;
